import { css } from 'linaria';

export const ceilingsLightingTypeTitle = css`
  @media (--to-desktop) {
    margin-bottom: 8px;
  }
`;

export const ceilingsLightingTypeText = css`
  margin-bottom: 32px;

  @media (--only-mobile) {
    margin-bottom: 24px;
  }
`;
